import { XMarkIcon } from "@heroicons/react/24/outline";
import { useSearchParams } from "react-router-dom";
import Button from "src/components/form/Button";
import Search from "src/components/form/Search";
import Image from "src/components/elements/Image";
import MenuItemTextHighlighter from "src/components/navigation/MenuItemTextHighlighter";
import { outerPages } from "src/config/host";
import { isSVGString, searchMenu } from "src/helpers";
import { classNames } from "src/helpers/classNames";
import useDevice from "src/hooks/useDevice";

const TravelLeftNavigationMenu = ({ useCustomSidbar, mordernDesign, isNotification, sidepanelWidth, isMenu, setIsMenu, menus = [], simulatedMenus = [], setSimulatedMenus = () => {}, keyword = "", setKeyword = () => {}, handleMenuClick = () => {} }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentGroupSlug = searchParams.get("group") || searchParams.get("travel-group");
  const device = useDevice();

  const isOuterPage = outerPages.includes(window.location.href);

  const searchOnMenus = (keywordStr = "") => {
    if (!keywordStr) {
      setSimulatedMenus(menus);
    } else {
      setSimulatedMenus(searchMenu(menus, keywordStr));
    }
  };

  const handleSelectTravelGroup = (groupItem) => {
    const slug = groupItem?.slug || groupItem?._id;
    if (slug) {
      setSearchParams({ group: slug });
    }
    handleMenuClick();
  };

  const displayedMenus = simulatedMenus?.length > 0 ? simulatedMenus : menus;

  return (
    <>
      <div
        className={classNames("fixed left-0 top-0 z-[49] block h-full w-screen bg-black transition-all duration-200 xl:z-[39]", mordernDesign ? "!hidden" : "xl:hidden", isMenu ? "visible opacity-80" : "invisible opacity-0")}
        onClick={() => setIsMenu(!isMenu)}
      />
      <div
        className={classNames(
          "flex h-full w-full flex-col bg-white transition-all duration-200",
          useCustomSidbar ? "" : "!bg-leftNavColor",
          mordernDesign
            ? classNames("relative max-h-screen border-black/5 xl:border-b", isNotification ? "xl:max-h-[calc(100vh-13rem)]" : "xl:max-h-[calc(100vh-9rem)]")
            : classNames(!isMenu || isOuterPage ? "-translate-x-full" : "translate-x-0", "fixed left-0 top-0 z-50 shadow-lg xl:absolute xl:z-40"),
        )}
        style={{ maxWidth: device === "desktop" ? sidepanelWidth : 310 }}>
        {isMenu && device === "mobile" && (
          <Button
            buttonIcon={XMarkIcon}
            buttonIconPosition={"right"}
            buttonClasses={"!bg-transparent !absolute top-2 left-full !ml-2 !w-10 !h-10 !px-0 !rounded-full !border-2 !border-white"}
            buttonIconClass={"!w-6 !h-6 !stroke-2"}
            buttonFunction={() => setIsMenu(!isMenu)}
          />
        )}
        {!useCustomSidbar && menus.length > 15 && (
          <div className={classNames("flex-shrink-0 px-4 pb-2 pt-3")}>
            <Search
              value={keyword}
              placeholder="Search"
              divClasses={classNames("!rounded")}
              onChange={(e) => {
                setKeyword(e.target.value);
                searchOnMenus(e.target.value);
              }}
            />
          </div>
        )}
        <div className={classNames("scrollbar h-full w-full space-y-1 overflow-auto px-4 py-2 pb-10")}>
          <div className="space-y-1">
            {displayedMenus.map((item, index) => {
              const isActive = currentGroupSlug ? currentGroupSlug === item.slug || currentGroupSlug === item._id : index === 0;

              return (
                <button
                  key={item._id || item.slug || index}
                  type="button"
                  onClick={() => handleSelectTravelGroup(item)}
                  className={classNames(
                    "flex min-h-10 w-full select-none items-center justify-between rounded px-3 py-2 text-left transition-all",
                    isActive ? "!bg-leftNavActiveColor font-medium text-leftNavActiveTextColor" : "font-medium text-leftNavTextColor hover:bg-leftNavActiveColor hover:text-leftNavActiveTextColor",
                  )}>
                  <div className="group flex min-w-0 flex-1 items-center">
                    {item?.image && (
                      <div className={classNames("nav-icon mr-2 h-5 w-5 flex-shrink-0", isSVGString(item.image) ? "" : "flex items-center justify-center")}>
                        {isSVGString(item.image) ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.image.replace(/stroke-width="[^"]*"/g, 'stroke-width="1.7"'),
                            }}
                          />
                        ) : (
                          <Image
                            src={item.image}
                            alt={"Menu image"}
                            classes=""
                            hideImageOnError
                          />
                        )}
                      </div>
                    )}
                    <span
                      className="min-w-0 flex-1 break-words text-base font-medium leading-tight"
                      title={item.name}>
                      <MenuItemTextHighlighter
                        text={item.name}
                        highlight={keyword ? keyword.toLowerCase() : ""}
                      />
                    </span>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default TravelLeftNavigationMenu;
